// extracted by mini-css-extract-plugin
export default {"products":"qu-z","card":"ru-z","oosMessaging":"su-z"};